<div *ngIf="(online$ | async) !== true" class="c-online-status" [style.background-image]="'url(' + backgroundImage + ')'">
	<div class="c-online-status__content">
		<h1 class="u-title">Toerisme Vlaanderen</h1>

		<p class="u-title-sub u-text--uppercase u-m-bottom--xs">{{ brandName }}</p>

		<div class="p-landing-page__login anim-reveal-page">
			<div class="u-text--light u-text--sm">
				<strong>{{ brandName }} is momenteel niet bereikbaar.</strong>
				<p>Mogelijke oorzaken zijn onderhoudswerken aan de applicatie of een probleem met je internetverbinding.</p>
			</div>
		</div>
	</div>
</div>
